var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalletTruckRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_767)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_652_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#C24646",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.2738 16.8735L22.7034 14.8137L21.7422 15.3631L25.2667 17.4228L26.2738 16.8735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8101 17.6973L21.2855 15.6833L20.3242 16.1869L23.8488 18.2467L24.8101 17.6973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0839 18.155C25.0381 18.2008 24.0769 18.7044 24.1227 18.7044V19.9402L25.0839 19.3909V18.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4299 19.1164L23.3912 18.5212L19.8208 16.4614L18.8594 17.0565L22.4299 19.1164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5429 19.5283C25.5429 19.6198 25.4971 19.7114 25.4056 19.7573L23.9866 20.5812C23.9408 20.5812 23.8951 20.627 23.8493 20.627C23.712 20.627 23.6204 20.5355 23.6204 20.3981V18.9791L22.6133 19.5284V23.6024C22.6591 23.5566 26.6414 21.2678 26.4583 21.4051V17.3312L25.5429 17.8347V19.5283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5674 24.1973C22.476 24.2431 22.3843 24.2431 22.3385 24.1973L18.3104 21.8627C18.2189 21.8169 18.1731 21.7254 18.1731 21.6796V18.3838C18.1272 18.4296 14.0991 20.764 14.1449 20.7183L23.5745 26.1655L30.3034 22.2747L27.0076 20.3522V21.5424C27.0076 21.6339 26.9618 21.7255 26.8703 21.7713C21.24 24.9295 22.9792 23.9226 22.5674 24.1973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 21.4966L22.1993 23.5563V19.4824L18.6289 17.4226V21.4966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6695 24.0142C30.6237 24.06 29.7998 24.5177 29.8456 24.4719C29.9829 24.7465 30.0745 25.1585 30.0287 25.4331L30.5781 25.1127C30.7612 25.0212 30.7612 24.7465 30.7612 24.6092C30.7612 24.4261 30.7154 24.243 30.6695 24.0142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6638 28.0425C23.4806 28.1339 23.3433 27.951 22.8398 27.722C23.2517 28.2714 23.3891 28.8664 23.3891 29.3241L23.9385 29.0037C24.0758 28.9122 24.1216 28.7291 24.1216 28.5002C24.1216 28.3171 24.0758 28.0883 23.9843 27.8593L23.6638 28.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9277 27.4931C21.47 27.2185 21.1953 27.4017 21.1953 27.905C21.1953 28.5001 21.653 29.2784 22.1565 29.5987C22.5228 29.7819 22.7974 29.7819 22.889 29.3698C22.9805 28.7748 22.5228 27.8592 21.9277 27.4931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4344 24.7466L28.3359 25.3416C28.4732 25.5247 28.6563 25.662 28.7936 25.7535C29.1598 25.9824 29.4802 25.8908 29.5261 25.4789C29.5717 25.2501 29.4802 24.9297 29.4344 24.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5332 23.5565V22.6867L23.667 26.6233C23.5755 26.6692 23.4839 26.6692 23.438 26.6233L13.8711 21.0846V21.9544C25.269 28.5917 12.0401 20.9015 23.5296 27.5389C23.85 27.4014 30.6705 23.4192 30.5332 23.5565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1976 24.5635L15.747 24.2431C15.8843 24.1516 15.9301 23.9685 15.9301 23.7396L14.6484 23.0071C14.9687 23.3735 15.2435 24.0143 15.1976 24.5635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5898 7.76416H19.544C19.4982 7.76416 19.4067 7.80998 19.3609 7.80998L14.6003 10.5564C14.3714 10.6937 14.1426 11.0141 14.0968 11.2889C14.0511 11.472 14.0511 11.6093 14.0969 11.655L16.2942 14.5387C16.3857 14.676 16.4315 14.8133 16.4315 14.9964V18.75C16.523 18.7041 17.3013 18.2464 17.2554 18.2464V14.2183C17.2554 14.0352 17.3013 13.8521 17.3469 13.7148L19.5898 8.31338C19.6813 8.03878 19.6357 7.80997 19.5898 7.76416ZM16.7975 12.9367C16.7975 12.9825 16.7517 12.9825 16.7517 13.0282L16.5228 13.1655L15.1953 11.4261C15.1953 11.3803 15.2411 11.1971 15.3326 11.1515L18.2165 9.45778L16.7975 12.9367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7325 22.7325C13.2748 22.4579 13 22.641 13 23.1444C13 23.7394 13.4577 24.5177 13.9613 24.8381C14.3275 25.0671 14.6479 24.9754 14.6937 24.5635C14.7852 23.9225 14.2817 23.0529 13.7325 22.7325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_652_767",
    x: 0.5,
    y: 0.5,
    width: 43.7148,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_652_767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_652_767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletTruckRedIcon);
export default __webpack_public_path__ + "static/media/PalletTruckRedIcon.39eb983257e9c5fec219270533dc0b64.svg";
export { ForwardRef as ReactComponent };